//imports
import {
    MANUFACTURERS_REFRESH_DEVICES_CONFIG_OPEN_MODAL,
    MANUFACTURERS_REFRESH_DEVICES_CONFIG_REQUEST,
    MANUFACTURERS_REFRESH_DEVICES_CONFIG_RESULT,
    MANUFACTURERS_REFRESH_DEVICE_CONFIG_REQUEST,
    MANUFACTURERS_REFRESH_DEVICE_CONFIG_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    resultSingle: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MANUFACTURERS_REFRESH_DEVICES_CONFIG_OPEN_MODAL:
            return { ...state, openModal: true }

        case MANUFACTURERS_REFRESH_DEVICES_CONFIG_REQUEST:
            return { ...state, loading: true }

        case MANUFACTURERS_REFRESH_DEVICES_CONFIG_RESULT:
            return { ...state, loading: false, result: action.payload }

        case MANUFACTURERS_REFRESH_DEVICE_CONFIG_REQUEST:
            return { ...state, loading: true }

        case MANUFACTURERS_REFRESH_DEVICE_CONFIG_RESULT:
            return { ...state, loading: false, resultSingle: action.payload }

        case CLEAR_REDUX:
            return ["", "MANUFACTURER_REFRESH_DEVICES_CONFIG"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
